import { render } from "./ComponentGoogleButton.vue?vue&type=template&id=54d35965&scoped=true"
import script from "./ComponentGoogleButton.vue?vue&type=script&lang=js"
export * from "./ComponentGoogleButton.vue?vue&type=script&lang=js"

import "./ComponentGoogleButton.vue?vue&type=style&index=0&id=54d35965&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d35965"]])

export default __exports__